import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) {
    return <Navigate to="/" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (res.ok) navigate("/", { replace: true });
    else setError(res.error || "Anmeldung fehlgeschlagen.");
  };

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-6 py-12 bg-zinc-950"
      style={{
        backgroundImage:
          "url(https://images.unsplash.com/photo-1775058800676-bff513fc73eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHx0aGVhdGVyJTIwc3RhZ2UlMjBjdXJ0YWluc3xlbnwwfHx8fDE3NzkzNTQwNTN8MA&ixlib=rb-4.1.0&q=85)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-zinc-950/60" />
      <div className="relative w-full max-w-md">
        <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20 p-10">
          <img
            src="/branding/logo.jpg"
            alt="Theatergruppe Seekirchen"
            className="h-16 w-auto object-contain mb-6"
            data-testid="login-logo"
          />
          <p className="text-[10px] uppercase tracking-[0.3em] font-bold text-red-700 mb-3">
            Theatergruppe Seekirchen
          </p>
          <h1 className="text-4xl font-black tracking-tight text-zinc-950 mb-2">
            Kassiersystem
          </h1>
          <p className="text-zinc-500 mb-8 text-base">
            Bitte melden Sie sich an, um die Kassa zu öffnen.
          </p>

          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-2 block">
                E-Mail
              </label>
              <input
                data-testid="login-email"
                type="email"
                autoFocus
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-14 px-4 text-lg border border-zinc-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zinc-950 bg-white"
                placeholder="admin@theater.at"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-2 block">
                Passwort
              </label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-14 px-4 text-lg border border-zinc-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zinc-950 bg-white"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div data-testid="login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-4 py-3">
                {error}
              </div>
            )}

            <button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full h-14 bg-zinc-950 hover:bg-zinc-800 text-white text-lg font-bold rounded-md transition disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {loading && <Loader2 className="h-5 w-5 animate-spin" />}
              Anmelden
            </button>
          </form>
        </div>
        <p className="text-center text-white/70 text-xs mt-6 tracking-wider">
          Internes System · Nur für Vereinsmitglieder
        </p>
      </div>
    </div>
  );
}
